import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

import { MessageIcon } from "../../../assets/Icons";
import { useDarkMode } from "../../../context/DarkModeContext";
import { Button } from "../../Reusable/Button";
import { Input } from "../../Reusable/Input";
import {
  ResetPasswordFormProps,
  ActionButtonsProps,
  FormContentProps,
} from "../types";

// Main Component
const ResetPasswordForm: React.FC<ResetPasswordFormProps> = ({
  isModal = false,
  onClose,
  onSignIn,
}) => {
  const [email, setEmail] = useState("");
  const navigate = useNavigate();
  const { darkMode } = useDarkMode();

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log("Reset link sent to:", email);
    // Add your password reset logic here
  };

  const handleSignInClick = () => {
    if (isModal && onSignIn) {
      onSignIn();
    } else {
      navigate("/signin");
    }
  };

  return (
    <div className="space-y-4">
      <FormContent
        email={email}
        setEmail={setEmail}
        onSubmit={handleSubmit}
        onClose={onClose}
        darkMode={darkMode}
      />
    </div>
  );
};

const ActionButtons: React.FC<ActionButtonsProps> = ({ onClose }) => (
  <div className="flex gap-4">
    {onClose && (
      <Button
        onClick={onClose}
        bgColor="bg-gray-200 dark:bg-gray-800"
        className="flex-1"
        borderRadius="rounded-lg"
      >
        Cancel
      </Button>
    )}
    <Button
      type="submit"
      bgColor="bg-gradient-to-r from-[#027EC2] to-[#039EF2]"
      textColor="text-white"
      className="flex-1 h-10"
      borderRadius="rounded-lg"
    >
      Submit
    </Button>
  </div>
);

const FormContent: React.FC<FormContentProps> = ({
  email,
  setEmail,
  onSubmit,
  onClose,
  darkMode,
}) => (
  <form onSubmit={onSubmit} className="space-y-4">
    <Input
      type="email"
      placeholder="Email address"
      value={email}
      onChange={(e) => setEmail(e.target.value)}
      required
      icon={<MessageIcon theme={darkMode ? "dark" : "light"} />}
    />
    <ActionButtons onClose={onClose} />
  </form>
);

export default ResetPasswordForm;
